import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { LanguageAware } from '../language-aware';
import { ActivatedRoute, Router } from '@angular/router';
import { NewSystemService } from 'src/app/services/new-system.service';

@Component({
  selector: 'app-customize-areas',
  templateUrl: './customize-areas.component.html',
  styleUrls: ['./customize-areas.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomizeAreasComponent extends LanguageAware implements OnInit {
  public maxAreaLen = 100;
  public readonly panicButtonsAreaStatus = 18;

  constructor(
    cdRef: ChangeDetectorRef,
    private router: Router,
    public ns: NewSystemService,
    private r: ActivatedRoute,
  ) {
    super(cdRef);
    this.tag = 'CustomArea';
    this.headerBar.showHeader({
      headerText: this.systems.activeSystem.hwType === 'FC' ? this.trans('systems.labels.nameTheGroups') : this.trans('systems.labels.nameTheAreas'),
      backUrl: '../add-system-complete',
      activatedRoute: this.r,
    });
    this.footerBar.showFooter(this.trans('general.skip'), this.trans('general.save'), false, false);
    this.footerBar.onButton1Click = () => {
      this.onSkip();
    };
    this.footerBar.onButton2Click = () => {
      this.onNext();
    };
    this.background.setGray();
    if (this.systems.activeSystem.zones.length !== 0) {
      this.progressBar.showProgress();
    }
    if (this.systems.activeSystem.hwType === 'SP3') {
      this.maxAreaLen = 23;
    }
  }

  ngOnInit(): void {
    this.progressBar.setProgressData(1, 2, 2);
  }

  private onSkip() {
    this.router.navigate(this.g.getHomeUrl());
  }

  private onNext() {
    if (this.systems.activeSystem.zones.length === 0) {
      this.router.navigate(this.g.getHomeUrl());
    } else {
      this.router.navigate(['../customize-zones'], { relativeTo: this.r });
    }
  }

  public submitNewName(areaId: number, areaName: string) {
    if (areaName === this.systems.activeSystem.areas.find((a) => a.id === areaId).name) {
      return;
    }
    if (areaName === '') {
      this.toaster.postError(this.trans('systems.errors.noAreaName'));
      return;
    }

    const systemId = this.systems.activeSystem.id;
    const oldName = this.systems.activeSystem.areas.find((a) => a.id === areaId).name;
    this.api.post('/change-area-name', { system_id: systemId, area_id: areaId, area_name: areaName }, true).subscribe(
      (result) => {
        if (!result.success) {
          this.toaster.postError(result.error);
          this.revertNameChange(systemId, areaId, oldName);
          return;
        }
        this.saveName(systemId, areaId, areaName);
        this.log('gut');
      },
      (error) => {
        this.toaster.postError(this.trans('auth.errors.serverSideError'));
        this.revertNameChange(systemId, areaId, oldName);
      }
    );
  }

  private revertNameChange(systemId: number, areaId: number, oldName: string) {
    const system = this.systems.getSystem(systemId);
    if (system === undefined) {
      return;
    }
    const area = system.areas.find((a) => a.id === areaId);
    if (area === undefined) {
      return;
    }
    area.name = oldName;
    this.systems.saveActiveSystem();
  }

  private saveName(systemId: number, areaId: number, newName: string) {
    const system = this.systems.getSystem(systemId);
    if (system === undefined) {
      return;
    }
    const area = system.areas.find((a) => a.id === areaId);
    if (area === undefined) {
      return;
    }
    area.name = newName;
  }
}
